import Icon from 'components/atoms/Icon';
import {
  CefrLevel,
  EnglishProficiencyStageActionFragment,
} from 'generated/graphql';
import { FC } from 'react';
import { TextInputField } from '@spotted-zebra-uk/ui-components';

interface IStageEnglishProficiencyAction {
  action: EnglishProficiencyStageActionFragment;
}

// Every other level's GraphQL name is already how it is written.
const formatCefrLevel = (level: CefrLevel): string =>
  level === CefrLevel.BelowA1 ? 'Below A1' : level;

const StageEnglishProficiencyAction: FC<IStageEnglishProficiencyAction> = ({
  action,
}) => (
  <div
    className="stage-test-action"
    data-testid="edit-project__stage-english-proficiency-action"
  >
    <Icon icon="language" className="stage-test-action__icon" />
    <TextInputField
      id={`english-proficiency-action-${action.id}`}
      disabled
      onChange={() => {}}
      value={`English proficiency test (min. ${formatCefrLevel(
        action.requiredCefrLevel
      )})`}
      className="stage-test-action__name-label"
    />
  </div>
);

export default StageEnglishProficiencyAction;
